const KIND_SLUG_CHAR_MAP = {
  а: "a",
  б: "b",
  в: "v",
  г: "h",
  ґ: "g",
  д: "d",
  е: "e",
  є: "ye",
  ж: "zh",
  з: "z",
  и: "i",
  і: "i",
  ї: "yi",
  й: "j",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "h",
  ц: "c",
  ч: "ch",
  ш: "sh",
  щ: "shch",
  ю: "yu",
  я: "ya",
  ь: "",
  ъ: "",
  ы: "y",
  э: "e",
  ё: "e",
};

export const slugifyKind = (kind = "") =>
  String(kind)
    .trim()
    .toLowerCase()
    .replace(/[а-яіїєґёъыэь]/g, (char) => KIND_SLUG_CHAR_MAP[char] ?? char)
    .replace(/[’'`ʼ]/g, "")
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const buildCategoryKindPath = (categorySlug, kind) => {
  const kindSlug = slugifyKind(kind);

  return categorySlug && kindSlug
    ? `/category/${categorySlug}/${kindSlug}`
    : "/products";
};

export const buildCategoryPath = (categorySlug) =>
  categorySlug ? `/category/${categorySlug}` : "/products";

export const buildPromotionCategoryPath = (categorySlug) =>
  categorySlug ? `/promotions/category/${categorySlug}` : "/promotions";

export const buildPromotionCategoryKindPath = (categorySlug, kind) => {
  const kindSlug = slugifyKind(kind);

  return categorySlug && kindSlug
    ? `/promotions/category/${categorySlug}/${kindSlug}`
    : buildPromotionCategoryPath(categorySlug);
};

export const findKindBySlug = (kinds = [], kindSlug = "") => {
  const normalizedSlug = String(kindSlug || "").trim().toLowerCase();

  return (
    kinds.find((kind) => slugifyKind(kind) === normalizedSlug) || null
  );
};
